/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import deploymentRoleBadgesModule from './deployment'
import elasticsearchRoleBadgesModule from './elasticsearch'
import observabilityRoleBadgesModule from './observability'
import securityRoleBadgesModule from './security'
import cloudConnectedRoleBadgesModule from './cloudConnected'

const ROLE_BADGES_MODULES = [
  deploymentRoleBadgesModule,
  elasticsearchRoleBadgesModule,
  observabilityRoleBadgesModule,
  securityRoleBadgesModule,
  cloudConnectedRoleBadgesModule,
]

export default ROLE_BADGES_MODULES
